import axios from 'axios'

import { http } from 'legacy/utils/http'

export function getFacility(facilityUUID) {
  return axios.get(`/api/v2/facilities/${facilityUUID}`, http.getHeadersV2()).then(res => res.data)
}
